import script from "./CoreUiChatHistoryMessageTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageTitle.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageTitle.vue?vue&type=style&index=0&id=1b157e58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b157e58"]])

export default __exports__